// Utility functions for gamepad selection management
// Separated from React components to avoid import issues in API contexts

// Function to check if we're in pavilion mode based on URL
export const isPavilionMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('pavilion');
};

// Function to get selected gamepad index from localStorage
export const getSelectedGamepadIndex = (): number | null => {
  if (typeof localStorage === 'undefined') return null;

  try {
    const stored = localStorage.getItem('pavilion-selected-gamepad');
    if (stored === null || isNaN(Number(stored))) return null;
    return Number(stored);
  } catch (error) {
    // Handle localStorage exceptions (private browsing, etc.)
    console.warn('[Gamepad Selection] localStorage read error:', error);
    return null;
  }
};

// Function to reset gamepad selection on new game/lobby (not on UI changes)
export const resetGamepadSelectionForNewSession = (): void => {
  if (isPavilionMode()) {
    try {
      localStorage.removeItem('pavilion-selected-gamepad');
      // Reset will happen automatically on next component mount via validation
    } catch (error) {
      // Handle localStorage exceptions (private browsing, etc.)
      console.warn('[Gamepad Selection] localStorage clear error:', error);
    }
  }
};

// Function to set selected gamepad index in localStorage
export const setSelectedGamepadIndex = (index: number | null): void => {
  try {
    if (index !== null) {
      localStorage.setItem('pavilion-selected-gamepad', index.toString());
    } else {
      localStorage.removeItem('pavilion-selected-gamepad');
    }
  } catch (error) {
    // Handle localStorage exceptions (storage full, private browsing, etc.)
    console.warn('[Gamepad Selection] localStorage unavailable:', error);
  }
};

